var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNe = function SvgIconNe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M1.19 6.782A11.95 11.95 0 0 0 0 12c0 1.87.428 3.64 1.19 5.217L12 18.261l10.81-1.044A11.95 11.95 0 0 0 24 12c0-1.87-.428-3.64-1.19-5.218L12 5.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M1.19 17.218A12 12 0 0 0 12 24.001a12 12 0 0 0 10.808-6.783z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FF9811"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.19 6.782h21.618A12 12 0 0 0 12 0 12 12 0 0 0 1.19 6.782M12 16.174a4.174 4.174 0 1 0-.001-8.348 4.174 4.174 0 0 0 0 8.348"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconNe;